import { t } from '@trimble/i18n';
import { Component } from 'solid-js';
import { HeatmapSectionLabel } from '../../components/HeatmapSectionLabel';

export interface ColorStopsSectionHeaderProps {
  readonly addStopDisabled: boolean;
  readonly addStopTooltip: string;
  onAddStop(): void;
}

export const ColorStopsSectionHeader: Component<
  ColorStopsSectionHeaderProps
> = (props) => (
  <div
    class="flex items-center justify-between gap-2"
    data-testid="edit-palette-color-stops-header"
  >
    <HeatmapSectionLabel
      uppercase
      label={t('measurements.volumetric.gradient.colors')}
    />
    <modus-wc-tooltip
      content={props.addStopTooltip}
      position="bottom"
      class="shrink-0 [&_div]:flex"
    >
      <modus-wc-button
        type="button"
        color="tertiary"
        shape="square"
        size="sm"
        variant="borderless"
        // @ts-expect-error -- modus types do not support bool:disabled syntax
        bool:disabled={props.addStopDisabled}
        attr:aria-label={props.addStopTooltip}
        data-testid="edit-palette-add-color-stop"
        onClick={() => props.onAddStop()}
      >
        <modus-wc-icon name="add" size="sm" />
      </modus-wc-button>
    </modus-wc-tooltip>
  </div>
);
